import { ZoneEntity } from "@src/core/features";
export interface ZoneListProps {
    zones: ZoneEntity[];
    variant?: ZoneVariant;
}

export interface ZoneItemProps {
    zone: ZoneEntity;
    variant?: ZoneVariant;
    isSelected?: boolean;}

export interface ZoneMapProps {
    zones: ZoneEntity[];
}

export type ZoneVariant = "no-fly" | "safe-land";

export const VARIANT_NO_FLY = 'no-fly';
export const VARIANT_SAFE_LAND = 'safe-land';